import { render, staticRenderFns } from "./Dosing.vue?vue&type=template&id=6362640a"
import script from "./Dosing.vue?vue&type=script&lang=js"
export * from "./Dosing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports